import React, { useEffect, useState } from "react";
import { generateClient } from "aws-amplify/api";
import { listSlumSoccerBlogs } from "../graphql/queries";
import { BlogCard } from "../components/BlogCard";

const client = generateClient();

export function Blogs(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    let pendingData = await client.graphql({
      query: listSlumSoccerBlogs,
    });
    
    // Sort the blogs by date in descending order
    const sortedBlogs = pendingData["data"]["listSlumSoccerBlogs"].items.sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
    
    setData(sortedBlogs);
  };

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 animate__animated animate__bounceInUp">
      <div className="container mx-auto px-9">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-5">
            Blogs
            <div className="h-1 w-full bg-orange-500 mt-2"></div>
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">Our Blogs</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {data.map((blog) => 
                <BlogCard key={blog.blogId} blog={blog} />
            )}
        </div>
      </div>
    </section>
  );
}